import { render, staticRenderFns } from "./PushOrder.vue?vue&type=template&id=67bda507&"
import script from "./PushOrder.vue?vue&type=script&lang=js&"
export * from "./PushOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports